//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { previewFilesHttp } from "@/api/file/files";
export default {
  name: "previewFilePage",
  components: {},
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      loading: false,
      configData: {},
      fileTypeList: ["html", "png", "gif", "jpg"],
      fileUrl: "",
      fileSuffix: ""
    };
  },
  computed: {},
  mounted: function mounted() {
    this.setfileUrlAndSuffix();
    this.fileConfigFn();
  },
  methods: {
    setfileUrlAndSuffix: function setfileUrlAndSuffix() {
      this.fileUrl = this.$route.query.fileUrl;
      var index = this.$route.query.fileUrl.lastIndexOf(".");
      this.fileSuffix = this.$route.query.fileUrl.substr(index + 1);
    },
    fileConfigFn: function fileConfigFn() {
      var _this = this;

      this.loading = true;

      if (this.fileTypeList.indexOf(this.fileSuffix) < 0) {
        previewFilesHttp(this.fileUrl).then(function (_ref) {
          var data = _ref.data;

          if (data.code == 0) {
            _this.configData = data.data.params;

            _this.appendScript();
          } else {
            _this.loading = false;

            _this.$notify.error({
              title: "错误",
              message: "\u9884\u89C8\u51FA\u9519,\u8BF7\u7A0D\u540E\u91CD\u8BD5,".concat(data.msg)
            });
          }
        }).catch(function (error) {
          _this.loading = false;

          _this.$notify.error({
            title: "错误",
            message: "\u9884\u89C8\u51FA\u9519,\u8BF7\u7A0D\u540E\u91CD\u8BD5,".concat(error.msg)
          });
        });
      } else {
        window.location.href = this.fileUrl;
      }
    },
    appendScript: function appendScript() {
      var _this2 = this;

      var al = document.getElementsByTagName("script");
      var scriptSrc = [];

      for (var i = 0; i < al.length; i++) {
        scriptSrc.push(al[i].getAttribute("src"));
      }

      if (scriptSrc.indexOf(this.configData.api) < 0) {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = this.configData.api;
        document.getElementsByTagName("head")[0].appendChild(script);

        script.onload = script.onreadystatechange = function () {
          new DocsAPI.DocEditor("iframeEditor", _this2.configData.config);
          _this2.loading = false;
          script.onload = script.onreadystatechange = null;
        };
      } else {
        new DocsAPI.DocEditor("iframeEditor", this.configData.config);
        this.loading = false;
      }
    }
  },
  destroyed: function destroyed() {},
  watch: {},
  filters: {}
};